const indicatorStatusColor = (indicatorStatus, theme) => {
  var _a;
  const {
    colors: {
      variant: { darker: themeColors }
    }
  } = theme;
  const defaultColor = themeColors.info;
  const colorMapping = {
    info: themeColors.info,
    primary: themeColors.primary,
    success: themeColors.success,
    warning: themeColors.warning,
    danger: themeColors.danger,
    default: themeColors.default,
    gray: themeColors.gray
  };
  return (_a = colorMapping[indicatorStatus]) != null ? _a : defaultColor;
};
export default indicatorStatusColor;
